const isValueMissing = (value) => {
  return value === undefined || value === null;
};

export default isValueMissing;
